/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { WorkFlow } from "./types";

//** REST Fetch Abstraction (to decouple dependency on axios) */
export interface IHttpRequest {
  get<T = any>(url: string, config?: any): Promise<T>;
  delete(url: string, config?: any): Promise<any>;
  post<T = any>(url: string, data?: any, config?: any): Promise<T>;
  put<T = any>(url: string, data?: any, config?: any): Promise<T>;
}

/* Promise with time delay */
export const delay = (ms: number) => {
  return new Promise<void>((resolve) => setTimeout(() => resolve(), ms));
};

export const getSubscriptionWorkflow = (flow?: string): WorkFlow =>
  flow === "subscribe with referral" ? "promo" : "organic";
